
import RcDomainObject from "@/domain/common/RcDomainObject.js";
import PaymentMap from "./PaymentMap";
import StringUtils from "../../../utils/StringUtils";

export default class Payment extends RcDomainObject {
  
  static MODEL_NAME = "Payment";
  
  constructor(domain, data) {
    super(domain, data, Payment.MODEL_NAME);
  }
  
  static Fields = {
    AMOUNT: "amount",
    TYPE: "type",
    NOTES: "notes",
    METHOD: "method",
  }
  
  static Values = {
    Method: {
      CREDIT: "credit",
      OVER_PAYMENT: "overpayment",
      CREDITCARD: "creditcard",
      ETRANSFER: "etransfer",
      CHEQUE: "cheque",
      STRIPE: "stripe",
      QUICKBOOKS: "quickbooks"
    }
  }

  amount() {
    return this.getString(Payment.Fields.AMOUNT);
  }

  fields() {
    return Payment.FIELDS;
  }

  type() {
    return this.getString(Payment.Fields.TYPE);
  }

  isOverpaymentType() {
    return StringUtils.cic("overpayment", this.type());
  }

  method() {
    return this.getString(Payment.Fields.METHOD);
  }

  notes() {
    return this.getString(Payment.Fields.NOTES);
  }
  
  find() {
    var keys = this.keys();
    var found = new PaymentMap(this.domain, {} );
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.invoices().payments().findById(key);
      var item = new Payment(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found.first();
  }

  methodDisplay() {
    switch (this.method()) {
      case Payment.Values.Method.CREDIT:
        return "Credit";
      case Payment.Values.Method.OVER_PAYMENT:
        return "Over Payment";
      case Payment.Values.Method.CREDITCARD:
        return "Credit Card";
      case Payment.Values.Method.ETRANSFER:
        return "E-Transfer";
      case Payment.Values.Method.CHEQUE:
        return "Cheque";
      case Payment.Values.Method.STRIPE:
        return "Stripe";
      case Payment.Values.Method.QUICKBOOKS:
        return "QuickBooks";
      default:
        return this.method();
    }
  }
}